// const API_URL = 'https://api-core.saphytedev.com';
// const API_URL = 'https://api-saphyte-master-if.saphytedev.com';
// const GO_API_URL = 'https://goapi-core.saphytedev.com';
// const API_URL = 'https://api-instantfunding.instantfsvc.com';
// const GO_API_URL = 'https://api-instantfunding.instantfsvc.com';
// const environment = {
//     API_BASE_URL: API_URL,
//     GO_API_BASE_URL: GO_API_URL,
//     FEATURES: {
//         IS_PROP: true,
//         PRODUCTS: true,
//         HAS_TRIAL: true,
//         BANNERS: true,
//         RULES_SECTION: true,
//         ACCOUNT_SCALING: true,
//         CHALLENGES_SECTION: true,
//         THEME_CHANGE: true,
//         REGISTER_SECTION: true,
//         SMART_DRAWDOWN: true
//     },
//     THEME_COLORS: {
//         PRIMARY: '#7270FF',
//         BLACK: '#132239',
//         BACKGROUND: '#F6F6F6',
//         BLACK_50_TEXT: '#8E8E8E',
//         BLACK_20_STROKE: '#D2D2D2',
//         BLACK_8_DIVIDER: '#EDEDED',
//         BRAND_HOVER: '#FF4885',
//         BLACK_HOVER: '#2A2A2A',
//         SYSTEM_GREEN: '#00E51B',
//         SYSTEM_YELLOW: '#FF7011',
//         SYSTEM_RED: '#FF0000'
//     },
//     TITLE_FONT_FAMILY: 'Rotonto',
//     CRYPTO_LOGO: true,
//     DAILY_RESET_HOUR: 17,
//     TIMEZONE: 'America/New_York'
// };
// const environmentCrypto = {
//     API_BASE_URL: 'https://api-ifcrypto.instantfsvc.com',
//     GO_API_BASE_URL: 'https://api-ifcrypto.instantfsvc.com',
//     // API_BASE_URL: 'https://api-if-endpoint-paths.saphytedev.com',
//     // GO_API_BASE_URL: 'https://goapi-core.saphytedev.com',
//     FEATURES: {
//         IS_PROP: true,
//         PRODUCTS: true,
//         HAS_TRIAL: true,
//         BANNERS: false,
//         RULES_SECTION: false,
//         ACCOUNT_SCALING: false,
//         CHALLENGES_SECTION: false,
//         THEME_CHANGE: false,
//         REGISTER_SECTION: false,
//         SMART_DRAWDOWN: false
//     },
//     THEME_COLORS: {
//         PRIMARY: '#FF1764',
//         BLACK: '#1E1E1E',
//         BACKGROUND: '#F6F6F6',
//         BLACK_50_TEXT: '#8E8E8E',
//         BLACK_20_STROKE: '#D2D2D2',
//         BLACK_8_DIVIDER: '#EDEDED',
//         BRAND_HOVER: '#FF4885',
//         BLACK_HOVER: '#2A2A2A',
//         SYSTEM_GREEN: '#00A800',
//         SYSTEM_YELLOW: '#FF7011',
//         SYSTEM_RED: '#FF3111'
//     },
//     TITLE_FONT_FAMILY: 'Onest',
//     CRYPTO_LOGO: true,
//     DAILY_RESET_HOUR: 17,
//     TIMEZONE: 'America/New_York'
// };
// let envToExport = environment;
// // if (window.location.hostname === 'ifcp-crypto-theme.saphytedev.com') {
// envToExport = environmentCrypto;
// // }
// export default envToExport;

// const environment = {
//     API_BASE_URL: API_URL,
//     GO_API_BASE_URL: GO_API_URL,
//     FEATURES: {
//         IS_PROP: true,
//         PRODUCTS: true,
//         HAS_TRIAL: false
//     },
//     DAILY_RESET_HOUR: 17,
//     TIMEZONE: 'America/New_York'
// };
// export default environment;

// let host = window.location.host;

// let API_URL = '';
// let GO_API_BASE_URL = '';

// if (/portal\.project-s/i.test(host)) {
//     API_URL = 'https://api-instantfunding.instantfsvc.com';
//     GO_API_BASE_URL = 'https://api-instantfunding.instantfsvc.com';
// } else {
//     let subdomain = host.split('.')[0];
//     API_URL = `https://api-${subdomain}.instantfsvc.com`;
//     GO_API_BASE_URL = `https://api-${subdomain}.instantfsvc.com`;
// }
let API_URL = 'https://api-instantfunding.instantfsvc.com';
let GO_API_BASE_URL = 'https://api-instantfunding.instantfsvc.com';
const environment = {
    API_BASE_URL: API_URL,
    GO_API_BASE_URL: GO_API_BASE_URL,
    FEATURES: {
        IS_PROP: true,
        PRODUCTS: true,
        HAS_TRIAL: false
    },
    DAILY_RESET_HOUR: 17,
    TIMEZONE: 'America/New_York'
};
export default environment;
